import { PortalCapabilities, TenantContext } from '../models/types';
import { hasElevatedAccess, hasElevatedAnyRole, PORTAL_ROLES } from './roles';

type CapabilityKey = keyof PortalCapabilities;

const hasCapability = (
  tenantOrRoles: TenantContext | string[] | undefined,
  capability: CapabilityKey,
  fallback: (roles: string[] | undefined) => boolean
): boolean => {
  if (Array.isArray(tenantOrRoles) || tenantOrRoles === undefined) {
    return fallback(tenantOrRoles);
  }
  if (tenantOrRoles.capabilities && capability in tenantOrRoles.capabilities) {
    return tenantOrRoles.capabilities[capability] === true;
  }
  return fallback(tenantOrRoles.roles);
};

export const canManageClientAccounts = (tenantOrRoles: TenantContext | string[] | undefined): boolean =>
  hasCapability(
    tenantOrRoles,
    'canManageClientAccounts',
    (roles) => hasElevatedAccess(roles, PORTAL_ROLES.manageClientAccounts)
  );

export const canDeployToAppCatalog = (tenantOrRoles: TenantContext | string[] | undefined): boolean =>
  hasCapability(
    tenantOrRoles,
    'canDeploySpfx',
    (roles) => hasElevatedAccess(roles, PORTAL_ROLES.deployToAppCatalog)
  );

export const canUseCapaRegister = (tenantOrRoles: TenantContext | string[] | undefined): boolean =>
  hasCapability(
    tenantOrRoles,
    'canUseCapa',
    (roles) => hasElevatedAnyRole(roles, [PORTAL_ROLES.manageClientAccounts, PORTAL_ROLES.qualityReviewer])
  );

export const canUseRisk = (tenantOrRoles: TenantContext | string[] | undefined): boolean =>
  hasCapability(
    tenantOrRoles,
    'canUseRisk',
    (roles) => hasElevatedAccess(roles, PORTAL_ROLES.manageClientAccounts)
  );

export const canReviewQuality = (tenantOrRoles: TenantContext | string[] | undefined): boolean =>
  hasCapability(
    tenantOrRoles,
    'canUseCapa',
    (roles) => hasElevatedAccess(roles, PORTAL_ROLES.qualityReviewer)
  );

export const canUseAiAdmin = (tenantOrRoles: TenantContext | string[] | undefined): boolean =>
  hasCapability(
    tenantOrRoles,
    'canReviewAiUsage',
    (roles) => hasElevatedAnyRole(roles, [PORTAL_ROLES.manageClientAccounts, PORTAL_ROLES.aiPolicyManager, PORTAL_ROLES.aiUsageReviewer])
  );
